import React from "react";
import { Visual } from "../Visual/Visual";
import VisualColunas from "../VisualColunas/VisualColunas";
import VisualVariacoes from "../VisualVariacoes/VisualVariacoes";
import "./styles";
import { VisualMainContainer } from "./styles";

interface VisualMainProps {}

const VisualMain: React.FC<VisualMainProps> = ({}) => {
  return (
    <VisualMainContainer>
      <Visual configIn="configuracoes" />
      <VisualColunas configIn="configuracoes" />
      <VisualVariacoes configIn="configuracoes" />
    </VisualMainContainer>
  );
};

export default VisualMain;
